import { css, html, LitElement } from 'lit';
import { FACEBOOK_PAGE } from '../../constants.js';
import { customElement, query } from 'lit/decorators.js';
import common from '../../styles/common.js';
import adoptStyleSheet from '../../utils/adoptStyleSheet.js';

@customElement('facebook-bar')
class FacebookBar extends LitElement {
  static styles = [
    common,
    css`
      #container, #container span {
        height: 70px;
        width: 500px;
      }
      
      #container {
        margin: 0 auto;
      }
      
      #container iframe {
        visibility: visible;
      }
    `
  ];

  @query('#container')
  container;

  async firstUpdated() {
    await this.updateComplete;

    this.tryAttachBar(document.querySelector('#fb-bar'));
  }

  render() {
    return html`<div id="container"></div>`;
  }

  tryAttachBar(realBar) {
    if (!realBar.classList.contains('fb_iframe_widget')) {
      setTimeout(() => this.tryAttachBar(realBar), 200);
    } else {
      this.attachBar(realBar);
    }
  }

  attachBar(realBar) {
    this.shadowRoot.adoptedStyleSheets = [
      ...this.shadowRoot.adoptedStyleSheets,
      adoptStyleSheet('style[data-fbcssmodules]')
    ];

    const clone = realBar.cloneNode(true);
    clone.classList.remove('hidden');

    const span = clone.querySelector('span');
    span.style.width = '';
    span.style.height = '';

    span.querySelector('iframe').style.visibility = '';

    this.container.appendChild(clone);
  }
}